import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/dailyMaterial/selectPage',
    method: 'GET',
    params: {
      ...params
    }
  })
}

// 导出主材成本统计
export function download (params) {
  return axios({
    url: '/dailyMaterial/download',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}
// 财务确认总金额
export function isAmount (data) {
  return axios({
    url: '/dailyMaterial/isAmount/' + data.id + '/' + data.isAmount,
    method: 'GET'
  })
}
// 财务确认预付款
export function isAdvancePay (data) {
  return axios({
    url: '/dailyMaterial/isAdvancePay/' + data.id + '/' + data.isAdvancePay,
    method: 'GET'
  })
}
